import { Injectable } from '@angular/core';
import { LifecycleListenerInterface } from '../interfaces/lifecycle-listener.interface';
import { EnvironmentManager } from '../managers/environment.manager';

@Injectable()
export class EnvironmentOverrideListener implements LifecycleListenerInterface {
  constructor(private readonly environmentManager: EnvironmentManager) {
  }

  async onFirstLoad(): Promise<void> {
    this.environmentManager.loadOverrideParameters();
  }

}